var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgWebastoTurnedOn = function SvgWebastoTurnedOn(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg3585",
    width: 44,
    height: 44,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -1008.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3924",
    fill: "currentColor",
    transform: "matrix(.29669 0 0 .30245 -292.74 1127.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect3914",
    d: "M1010.6-288.66h95.99v11.667h-95.99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3916",
    d: "M1035.2-134.67s7.778-9.632 7.778-17.854v-38.095h-5.834l12.375-15.645 12.02 15.468h-5.48v41.808c0 12.379-20.86 14.319-20.86 14.319z",
    transform: "translate(0 -160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3918",
    d: "M1010.3-294.67s7.778-9.632 7.778-17.854v-38.095h-5.834l12.374-15.645 12.021 15.468h-5.48v41.808c0 12.379-20.86 14.319-20.86 14.319z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3920",
    d: "M1085.1-294.67s7.778-9.632 7.778-17.854v-38.095h-5.834l12.374-15.645 12.022 15.468h-5.48v41.808c0 12.379-20.86 14.319-20.86 14.319z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3922",
    d: "M1060.1-294.67s7.778-9.632 7.778-17.854v-38.095h-5.834l12.374-15.645 12.022 15.468h-5.48v41.808c0 12.379-20.86 14.319-20.86 14.319z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWebastoTurnedOn);
export default ForwardRef;